import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FavCtx = createContext(null);
export const useFav = () => useContext(FavCtx);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const load = useCallback(async () => {
    if (user && user.id) {
      try { const { data } = await api.get("/favorites"); setIds(data.favorites); } catch (err) { console.error("Favorites load failed", err); }
    } else {
      try { setIds(JSON.parse(localStorage.getItem("cc_fav") || "[]")); } catch (err) { console.error("Favorites parse failed", err); setIds([]); }
    }
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const toggle = async (pid) => {
    const has = ids.includes(pid);
    const next = has ? ids.filter((x) => x !== pid) : [...ids, pid];
    setIds(next);
    if (user && user.id) {
      try { has ? await api.delete(`/favorites/${pid}`) : await api.post(`/favorites/${pid}`); } catch (err) { console.error("Favorite toggle failed", err); }
    } else {
      localStorage.setItem("cc_fav", JSON.stringify(next));
    }
  };

  const value = useMemo(() => ({ ids, toggle, has: (p) => ids.includes(p), reload: load }), [ids, load]);
  return <FavCtx.Provider value={value}>{children}</FavCtx.Provider>;
}
